// Visitor / verified identity header.
import type { ReactNode } from 'react';
import type { LiveChatConversation } from '../mockData.js';

export function VisitorIdentity({ convo }: { convo: LiveChatConversation }): ReactNode {
  const anonymous = convo.identity === 'anonymous';
  return (
    <section className="identity">
      <div className="avatar person large" />
      <div>
        <div className="identity-line">
          <h1 id="visitor-title">{convo.label}</h1>
          <span className="pill" id="anonymous-badge">
            {anonymous ? 'Anonymous' : 'Verified'}
          </span>
          <span className="pill green" id="live-status-pill">
            <i className="statusdot" />
            <span id="live-status">
              {convo.status === 'live'
                ? 'Live now'
                : convo.status === 'typing'
                ? 'Typing'
                : 'Waiting'}
            </span>
          </span>
        </div>
        <p>
          100xequine.com &nbsp;|&nbsp; <span id="identity-text">{convo.identityText}</span>
        </p>
      </div>
      <button className="menu" type="button" aria-label="Visitor options">
        ⋮
      </button>
    </section>
  );
}
